<template>

  <!--新年人物推荐-->
  <div class="activity-box">
    <img class="close-btn" src="../assets/year/close.png" alt="" @click.stop="closeFun">
    <div class="activity-con tranX50" :style="{width:conWidth}">
      <img class="bg" src="../assets/year/bg.png" alt="">
      <img class="fire tranX50" :class="animate2==1?'opacity0':''" src="../assets/year/fire.png" alt="">
      <img class="boom boom1" :class="animate1==1?'curr':''" src="../assets/year/boom.png" alt="">
      <img class="boom boom2" :class="animate1==1?'curr':''" src="../assets/year/boom.png" alt="">
      <!--<img class="pig" :class="animate3==0?'curr':''" src="../assets/year/pig.png" alt="" @click.stop="startPa">-->
      <img class="pig curr" v-if="animate3==0" src="../assets/year/pig.png" alt="" @click.stop="startPa">
      <img class="pig curr1" v-if="animate3==1" src="../assets/year/pig.png" alt="" @click.stop="startPa">
      <img class="pig" v-if="animate3==2" src="../assets/year/pig.png" alt="" @click.stop="startPa">
      <div class="paper paper-left" :class="animate2==1?'curr':''">
        <img class="paper-bg paper-bg-top" src="../assets/year/paper-bg.png" alt="">
        <img class="paper-img" src="../assets/year/paper1.png" alt="">
        <img class="paper-bg paper-bg-bottom" src="../assets/year/paper-bg.png" alt="">
      </div>
      <div class="paper paper-right" :class="animate2==1?'curr':''">
        <img class="paper-bg paper-bg-top" src="../assets/year/paper-bg.png" alt="">
        <img class="paper-img" src="../assets/year/paper2.png" alt="">
        <img class="paper-bg paper-bg-bottom" src="../assets/year/paper-bg.png" alt="">
      </div>
      <img class="person tranX50" :class="animate2==1?'opacity1':''" src="../assets/year/person.png" alt="">
      <!--<img class="person tranX50" :class="animate2==1?'opacity1':''" :src="recommendYear.timg" alt="">-->

      <span class="listen-btn tranX50" @click.stop="goVideoPlay(recommendYear.bid)">
        <img src="../assets/year/btn-bg.png" alt="">
        立即收听景区讲解
      </span>
    </div>
    <!--<audio id="fireAudio" src="https://filewc.geeker.com.cn/jpjs/upload/voice/20181126/iosvoicetest.mp3" controls="controls" loop="true" preload="auto" hidden style="opacity: 0"></audio>-->
    <audio id="fireAudio" src="https://filewc.geeker.com.cn/jpjs/upload/default/fire.mp3"  controls="controls" loop="true" preload hidden style="opacity: 0"></audio>
  </div>

</template>

<script>

  import {getCouponAtRandom} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        animate1: 0, //boom
        animate2: 0, //person  paper fire
        animate3: 2, //pig
        conWidth: '',
        fireAudio: '', //鞭炮音频

        canSetPlay: true,
        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    created(){
      this.apply();
    },
    props: ['recommendYear','shopid'],
    mounted(){
//      this.autoPlayMusic();
      this.initAnimate();
    },
    methods: {

      autoPlay(){
        let self = this;
        self.$nextTick(function() {
          self.fireAudio = document.getElementById('fireAudio');
          let play = function () {
            self.fireAudio.play();
            document.removeEventListener("touchstart", play, false);
          };
          self.fireAudio.play();
          document.addEventListener("WeixinJSBridgeReady", function () {
            play();
          }, false);
          document.addEventListener('YixinJSBridgeReady', function () {
            play();
          }, false);
          document.addEventListener("touchstart", play, false);
        })
      },

      initAnimate(){
        let self = this;
        let img = [];
        let flag = 0;
        let mulitImg = [
          require('../assets/year/bg.png'),
          require('../assets/year/fire.png'),
          require('../assets/year/boom.png'),
          require('../assets/year/btn-bg.png'),
          require('../assets/year/pig.png')
        ];
        let imgTotal = mulitImg.length;

        self.fireAudio = document.getElementById('fireAudio');

        for(var i = 0 ; i < imgTotal ; i++) {
          img[i] = new Image();
          img[i].src = mulitImg[i];
          img[i].onload = function () {
            //第i张图片加载完成
            flag++;
            if (flag == imgTotal) {
              self.animate3 = 0;
            }
          }
        }
      },

      //开始动画
      startPa(){
        if(!this.fireAudio.paused){
          this.fireAudio.pause();
        }
        let self = this;
        self.animate3 = 1;
        setTimeout(function(){
          self.firePlay();
          self.animate1 = 1;
        },300);

        setTimeout(function () {
          if(self.canSetPlay) {
            self.animate1 = 0;
            self.fireStop();
            self.animate2 = 1;
            self.fireAudio.src = self.recommendYear.video;
            self.firePlay();
          }
        }, 3000);
      },

      apply(){
        let winH = window.innerHeight ;
        this.conWidth = 610/967*0.8*winH + 'px'
      },

      //烟花声音特效
      firePlay(){
        this.fireAudio.play();
      },
      fireStop(){
        if(!this.fireAudio.paused){
          this.fireAudio.pause();
        }
      },

      // 音乐播放
      autoPlayMusic() {
        var self = this;
        // 自动播放音乐效果，解决浏览器或者APP自动播放问题
        function musicInBrowserHandler() {
          self.musicPlay(true);
          document.body.removeEventListener('touchstart', musicInBrowserHandler);
        }
        document.body.addEventListener('touchstart', musicInBrowserHandler);

        // 自动播放音乐效果，解决微信自动播放问题
        function musicInWeixinHandler() {
          self.musicPlay(true);
          document.addEventListener("WeixinJSBridgeReady", function () {
            self.musicPlay(true);
          }, false);
          document.removeEventListener('DOMContentLoaded', musicInWeixinHandler);
        }
        document.addEventListener('DOMContentLoaded', musicInWeixinHandler);
      },

      musicPlay(isPlay) {
        var audio = document.getElementById('fireAudio');
        if (isPlay && audio.paused) {
          audio.play();
        }
        if (!isPlay && !audio.paused) {
          audio.pause();
        }
      },

      //关闭弹窗
      closeFun(){
        this.animate1 = 0;
        this.animate2 = 0;
        this.fireStop();
        this.canSetPlay = false;
        this.$emit('close',{redEnvelopes: [], personEnvelopes: [], recommendPerson: "",recommendYear: ""});
      },

      //跳转到专辑详情页
      goVideoPlay(id){
        this.$router.push({
          path: `/video-play?${'id='+ id +'&spotid=&shopid='+ this.shopid + '&TimeStamp='+ this.TimeStamp}`
        });
      },

    },
  }
</script>

<style scoped>
  .tranX50{-webkit-transform: translateX(-50%);transform: translateX(-50%);}

  .activity-box{position: fixed;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.79);z-index:999;}
  .activity-con{position:absolute;left:50%;top:4.5%;width: 82%;height: 80%;max-width: 90%;}
  .bg{position:absolute;left:0;top:0;width: 100%;height:100%;}
  .fire{position:absolute;left:50%;top:14.78%;width: auto;height:60%;}
  .boom{position:absolute;left:50%;top:50.98%;width: auto;height:25.64%;opacity:0;-webkit-transform-origin:center;transform-origin: center; }
  .boom1{-webkit-transform: translateX(-50%) rotate(0deg);transform: translateX(-50%) rotate(0deg);}
  .boom2{-webkit-transform: translateX(-50%) rotate(35deg);transform: translateX(-50%) rotate(35deg);}
  .pig{position:absolute;left:55%;top:58.54%;width: auto;height:37.84%; }
  .paper{position:absolute;top:16.85%;width: 1.67rem;height: .4rem;overflow: hidden; z-index: 1; }
  .paper-left.curr{-webkit-animation: paper .8s linear .3s;animation: paper .8s linear .3s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .paper-right.curr{-webkit-animation: paper .8s linear .5s;animation: paper .8s linear .5s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .paper-left{left: 3.6%;}
  .paper-right{right: 3.6%;}
  .paper-bg{position: absolute;left: 0;width: 100%;height: .15rem;}
  .paper-bg-top{top: 0;}
  .paper-bg-bottom{bottom: 0;}
  .paper-img{position: absolute;top:.14rem;left: 0;width: 100%;height: 4.28rem;}
  .close-btn{position: absolute;left:50%;bottom:3.8%;width: .4rem;height: .4rem;margin-left: -.3rem;padding: .2rem;}
  .listen-btn{position: absolute;left:50%;bottom:.517rem;height: .67rem;padding:0 .2rem;font: .24rem/.63rem "Microsoft YaHei";color: #472b12;}
  .listen-btn img{position:absolute;left:0;top:0;width: 100%;height:100%; z-index: -1; }
  .person{position: absolute;left:50%;bottom:20%;width: auto;height: 60%;opacity: 0;}

  .boom1.curr{-webkit-animation: boom .5s linear .8s infinite;animation: boom .5s linear .8s infinite;}
  .boom2.curr{-webkit-animation: boom .5s linear 1s infinite;animation: boom .5s linear 1s infinite;}
  .pig.curr{-webkit-animation: pig 1.5s linear;animation: pig 1.5s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .pig.curr1{-webkit-animation: pig1 .7s linear;animation: pig1 .7s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .paper-left.curr .paper-bg-bottom{-webkit-animation: paper-bg .8s linear .2s;animation: paper-bg .8s linear .2s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .paper-right.curr .paper-bg-bottom{-webkit-animation: paper-bg .8s linear .5s;animation: paper-bg .8s linear .5s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .person.opacity1{-webkit-animation: opacity1 .3s linear .3s;animation: opacity1 .3s linear .3s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .fire.opacity0{-webkit-animation: opacity0 .3s linear;animation: opacity0 .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}


  /*移动动画*/
  @-webkit-keyframes pig {
    0%{left:55%;top:58.54%;opacity: 1;}
    25%{left:50%;top:55.54%;opacity: 1;}
    50%{left:55%;top:58.54%;opacity: 1;}
    75%{left:50%;top:55.54%;opacity: 1;}
    100%{left:55%;top:58.54%;opacity: 1;}
  }
  @keyframes pig {
    0%{left:55%;top:58.54%;opacity: 1;}
    25%{left:50%;top:55.54%;opacity: 1;}
    50%{left:55%;top:58.54%;opacity: 1;}
    75%{left:50%;top:55.54%;opacity: 1;}
    100%{left:55%;top:58.54%;opacity: 1;}
  }
  /*点燃动画*/
  @-webkit-keyframes pig1 {
    0%{left:55%;top:58.54%;opacity: 1;}
    55%{left:50%;top:55.54%;opacity: 1;}
    95%{left:55%;top:58.54%;opacity: .7;}
    100%{opacity: 0;}
  }
  @keyframes pig1 {
    0%{left:55%;top:58.54%;opacity: 1;}
    55%{left:50%;top:55.54%;opacity: 1;}
    95%{left:55%;top:58.54%;opacity: .7;}
    100%{opacity: 0;}
  }

  /*烟花动画*/
  @-webkit-keyframes boom {0%{opacity:1;}20%{opacity:0;}40%{opacity:1;}60%{opacity:0;}80%{opacity:1;}100%{opacity:0;}}
  @keyframes boom {0%{opacity:1;}20%{opacity:0;}40%{opacity:1;}60%{opacity:0;}80%{opacity:1;}100%{opacity:0;}}

  /*对联动画*/
  @-webkit-keyframes paper { from{height: .4rem;}to{height:4.54rem;}}
  @keyframes paper { from{height: .4rem;}to{height:4.54rem;}}

  /*对联动画圆柱*/
  @-webkit-keyframes paper-bg {
    0%{transform: rotateX(0deg);}
    20%{transform: rotateX(360deg);}
    40%{transform: rotateX(0deg);}
    60%{transform: rotateX(360deg);}
    80%{transform: rotateX(0deg);}
    100%{transform: rotateX(360deg);}
  }
  @keyframes paper-bg {
    0%{transform: rotateX(0deg);}
    20%{transform: rotateX(360deg);}
    40%{transform: rotateX(0deg);}
    60%{transform: rotateX(360deg);}
    80%{transform: rotateX(0deg);}
    100%{transform: rotateX(360deg);}
  }


  /*隐藏动画*/
  @-webkit-keyframes opacity0 {from{opacity: 1;}to{opacity: 0;}}
  @keyframes opacity0 {from{opacity: 1;}to{opacity: 0;}}
  /*显示动画*/
  @-webkit-keyframes opacity1 {
    from{opacity: 0;-webkit-transform: translateX(-50%) scale(.9);transform: translateX(-50%) scale(.9);}
    to{opacity: 1;-webkit-transform: translateX(-50%) scale(1);transform: translateX(-50%) scale(1);}
  }
  @keyframes opacity1 {
    from{opacity: 0;-webkit-transform: translateX(-50%) scale(.9);transform: translateX(-50%) scale(.9);}
    to{opacity: 1;-webkit-transform: translateX(-50%) scale(1);transform: translateX(-50%) scale(1);}
  }

</style>



// WEBPACK FOOTER //
// src/components/AlertYearPerson.vue